import React from 'react';
import { ArticleOverviewList } from '@ffw/randstad-shared-components/build';
import UI from '@UI/hoc/UI';

export default UI(ArticleOverviewList)();
